// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Hero/HeroLight-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Hero/HeroLight-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Hero/HeroLight-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'HeroLight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: normal;
}

@font-face {
  font-family: 'HeroLight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: bold;
}

@font-face {
  font-family: 'HeroLight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 300;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: bold;
}

body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
}

#sidebar {
  width: 280px;
  background-color: #373643;
  color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transition: all 0.2s ease-in-out;
  justify-self: stretch;
}

#sidebar-icon {
  display: none;
}

.inactive-sidebar {
  display: none !important;
}

.logo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

#side-logo {
  width: 150px;
}

.logo img {
  width: 30px;
  height: auto;
}

#sidebar-icon {
  filter: brightness(0) invert(1);
}

#taskButtons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}

#taskButtons .button, #addTask{
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

#taskButtons .button:hover, .viewButton:hover{
  background-color: rgba(255, 255, 255, 0.08);
  margin-left: 10px;
}

.active-sidebar {
  background-color: rgba(255, 255, 255, 0.08);
  margin-left: 10px;
}

#taskButtons .button img, #addTask img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

#addTask {
  background-color: rgba(24,203,150,0.8);
}

#addTask:hover {
  background-color: rgba(24,203,150,1) !important;
}

.Projects {
  margin-top: auto;
}

.projectsideHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.projectsideHead h3 {
  font-family: 'HeroLight', sans-serif;
  font-weight: normal;
  font-size: 20px;
  margin: 0;
  color: #ffffff;
}

#addProject {
  background-color: #373643;
  border: none;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

#addProject:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

#addProject img {
  width: 25px;
}

.projectsButtons {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.project-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.project-entry span {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
}

.project-entry button {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.removeBtn img {
  width: 20px;
  filter: brightness(0) invert(0.6);
}

@media (max-width: 950px) {
  #sidebar {
    width: 220px;
  }
}

@media (max-width: 768px) {
  body {
    flex-direction: column;
  }
  #sidebar {
    width: 100%;
    overflow-y: visible;
  }
  .sidebar-content {
    z-index: 2;
    position: relative;
  }
  #taskButtons {
    margin-bottom: 0;
  }
  #sidebar-icon {
    display: block;
  }
  .logo {
    margin: 0;
  }
  .sidebar-content {
    margin-top: 30px;
  }
  #sidebar-content {
    transition: display 0.5s ease-in-out;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+DAAiE;EACjE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+DAAkE;EAClE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["@font-face {\r\n  font-family: 'HeroLight';\r\n  src: url('./fonts/Hero/HeroLight-Regular.otf') format('opentype');\r\n  font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'HeroLight';\r\n  src: url('./fonts/Hero/HeroLight-Bold.otf') format('opentype');\r\n  font-weight: bold;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'HeroLight';\r\n  src: url('./fonts/Hero/HeroLight-Light.otf') format('opentype');\r\n  font-weight: 300;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Poppins';\r\n  src: url('./fonts/Poppins/Poppins-Regular.ttf') format('truetype');\r\n  font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Poppins';\r\n  src: url('./fonts/Poppins/Poppins-Bold.ttf') format('truetype');\r\n  font-weight: bold;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: 'Poppins', sans-serif;\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n#sidebar {\r\n  width: 280px;\r\n  background-color: #373643;\r\n  color: #ffffff;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  transition: all 0.2s ease-in-out;\r\n  justify-self: stretch;\r\n}\r\n\r\n#sidebar-icon {\r\n  display: none;\r\n}\r\n\r\n.inactive-sidebar {\r\n  display: none !important;\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n#side-logo {\r\n  width: 150px;\r\n}\r\n\r\n.logo img {\r\n  width: 30px;\r\n  height: auto;\r\n}\r\n\r\n#sidebar-icon {\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n#taskButtons {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n#taskButtons .button, #addTask{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n#taskButtons .button:hover, .viewButton:hover{\r\n  background-color: rgba(255, 255, 255, 0.08);\r\n  margin-left: 10px;\r\n}\r\n\r\n.active-sidebar {\r\n  background-color: rgba(255, 255, 255, 0.08);\r\n  margin-left: 10px;\r\n}\r\n\r\n#taskButtons .button img, #addTask img {\r\n  width: 20px;\r\n  height: 20px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n#addTask {\r\n  background-color: rgba(24,203,150,0.8);\r\n}\r\n\r\n#addTask:hover {\r\n  background-color: rgba(24,203,150,1) !important;\r\n}\r\n\r\n.Projects {\r\n  margin-top: auto;\r\n}\r\n\r\n.projectsideHead {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.projectsideHead h3 {\r\n  font-family: 'HeroLight', sans-serif;\r\n  font-weight: normal;\r\n  font-size: 20px;\r\n  margin: 0;\r\n  color: #ffffff;\r\n}\r\n\r\n#addProject {\r\n  background-color: #373643;\r\n  border: none;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n#addProject:hover {\r\n  background-color: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n#addProject img {\r\n  width: 25px;\r\n}\r\n\r\n.projectsButtons {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.project-entry {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.project-entry span {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.project-entry button {\r\n  background: transparent;\r\n  border: none;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 0;\r\n}\r\n\r\n.removeBtn img {\r\n  width: 20px;\r\n  filter: brightness(0) invert(0.6);\r\n}\r\n\r\n@media (max-width: 950px) {\r\n  #sidebar {\r\n    width: 220px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  body {\r\n    flex-direction: column;\r\n  }\r\n  #sidebar {\r\n    width: 100%;\r\n    overflow-y: visible;\r\n  }\r\n  .sidebar-content {\r\n    z-index: 2;\r\n    position: relative;\r\n  }\r\n  #taskButtons {\r\n    margin-bottom: 0;\r\n  }\r\n  #sidebar-icon {\r\n    display: block;\r\n  }\r\n  .logo {\r\n    margin: 0;\r\n  }\r\n  .sidebar-content {\r\n    margin-top: 30px;\r\n  }\r\n  #sidebar-content {\r\n    transition: display 0.5s ease-in-out;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
